import React from "react";
import { Skeleton } from "antd";
import { Wrapper } from "./wall.styles";
import { useWallDataContext } from "contexts/WallContext";
import WallHeader from "components/molecules/wall/WallHeader/wallHeader";
import ChaptersList from "components/molecules/wall/display/ChaptersList/ChaptersList";
import { useStoryDataContext } from "contexts/StoryContext";

function Wall() {
  const {story, storyLoading } = useStoryDataContext();
  const {chaptersLoading} = useWallDataContext();

  if (storyLoading || chaptersLoading) return (
    <Skeleton.Node active style={{width: "100%", height: 50, marginTop: 10}}/>
  );

  if (!story || !story.uuid) return <></>;

  return (
    <Wrapper>
      <WallHeader story={story}/>
      <ChaptersList/>
    </Wrapper>
  );
}

export default Wall;
